import { Button, Flex, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { needsInfoCategoryLabel } from "../../../constants/needs-info.ts"
import { type NeedsInfoItem } from "../../../types/lead.types.ts"
import { NeedsInfoDot } from "./NeedsInfoDot.tsx"

const { Text } = Typography

interface NeedsInfoStatusPopoverProps {
  items: NeedsInfoItem[]
  canEdit?: boolean
  onEdit: () => void
}

function NeedsInfoStatusPopover({
  items,
  canEdit,
  onEdit
}: NeedsInfoStatusPopoverProps) {
  const { t } = useTranslation()

  return (
    <Flex
      vertical
      gap={8}
      style={{ maxWidth: 260 }}
      data-testid={"needs-info-popover"}
    >
      <Text strong>
        {t("leadWorkspace.header.states.needsInfo.popoverTitle")}
      </Text>

      {items.length === 0 ? (
        <Text type={"secondary"} className={"text-xs"}>
          {t("leadWorkspace.header.states.needsInfo.noDetails")}
        </Text>
      ) : (
        <>
          <Text type={"secondary"} className={"text-xs"}>
            {t("leadWorkspace.header.states.needsInfo.waitingFor")}
          </Text>
          <Flex vertical gap={8}>
            {items.map((item) => (
              <Flex key={item.category} gap={6} align={"start"}>
                <NeedsInfoDot />
                <Flex vertical gap={0} className={"min-w-0"}>
                  <Text strong className={"text-xs"}>
                    {needsInfoCategoryLabel(t, item.category)}
                  </Text>
                  {item.description && (
                    <Text className={"text-xs"}>{item.description}</Text>
                  )}
                </Flex>
              </Flex>
            ))}
          </Flex>
        </>
      )}

      {canEdit && (
        <Button
          type={"link"}
          size={"small"}
          className={"self-start p-0"}
          onClick={onEdit}
        >
          {t("leadWorkspace.header.states.needsInfo.editLink")}
        </Button>
      )}
    </Flex>
  )
}

export { NeedsInfoStatusPopover }
